import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "container d-flex flex-column p-4" }
const _hoisted_2 = ["src"]
const _hoisted_3 = {
  key: 0,
  class: "alert alert-danger my-3"
}
const _hoisted_4 = { class: "row d-grid gap-2 col-10 mx-auto mt-2" }
const _hoisted_5 = ["disabled"]
const _hoisted_6 = {
  key: 0,
  class: "spinner-border spinner-border-sm",
  role: "status",
  "aria-hidden": "true"
}
const _hoisted_7 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("img", {
      class: "img-fluid",
      src: `data:image/jpeg;base64,${$setup.photo!.data}`
    }, null, 8, _hoisted_2),
    (!$setup.photo?.assessment.compliant)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.photo!.assessment.warnings, (warning) => {
            return (_openBlock(), _createElementBlock("span", { key: warning }, _toDisplayString(_ctx.$t(`compliance.${warning}`)), 1))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("button", {
        class: "btn btn-primary",
        type: "button",
        onClick: $setup.accept,
        disabled: $setup.isLoading
      }, [
        ($setup.isLoading)
          ? (_openBlock(), _createElementBlock("span", _hoisted_6))
          : _createCommentVNode("", true),
        _createTextVNode(_toDisplayString(_ctx.$t('actions.accept')), 1)
      ], 8, _hoisted_5),
      _createElementVNode("button", {
        class: "btn btn-danger",
        type: "button",
        onClick: $setup.takePhoto,
        disabled: $setup.isLoading
      }, _toDisplayString(_ctx.$t('actions.retake')), 9, _hoisted_7),
      _createElementVNode("input", {
        class: "d-none",
        type: "file",
        ref: "photoInput",
        accept: "image/*",
        capture: "environment",
        onChange: $setup.onPhotoTaken
      }, null, 544)
    ])
  ]))
}